import helpers from './helpers';
import sliders from './slider';
import bannerCarousel from './banner-carousel';
import SideNav from './sidenav';
import filter from './filter';
import 'modaal';
import 'moment';
import 'daterangepicker';
import simpleMap from './locations-simple';
import finddoctormeetteamtabs from './finddoctormeetteamtabs'

import newsCenter from './news-center';
import searchFilters from './search-filters';
import filterNavDropdown from './nav-filter-dropdown';

global.helpers = helpers;
global.$ = global.jQuery = $;

$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top + 80;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

function toggleHeaderState(headerEl, closeTarget) {
    headerEl = $(headerEl);

    headerEl.toggleClass('is-open-state');
    $('body, html').toggleClass('no-scroll');
    $('.js-mob-backdrop').toggle();

    if ($(this).attr("data-closes") !== "") {
        $('.js-header-close').attr('data-closes', closeTarget);
    }
}

function smoothScroll(clickedEl, scrollTo, scrollDuration) {
    $(clickedEl).on('click', function (event) {
        if (scrollTo != 'html, body') {
            scrollTo = $(this).attr("href");
        }

        smoothScrollTo(scrollTo, scrollDuration);
    })
}

function smoothScrollTo(scrollTo, scrollDuration, offset) {
    if (scrollTo == 'html, body') {
        $(scrollTo).animate({ scrollTop: 0 }, scrollDuration);
        return false;
    } else {
        var scroll = $(scrollTo);
        if (scroll && scroll.offset()) {
            return false;
        }
        let totalOffset = scroll.offset().top - 50;
        if (typeof offset !== "undefined") {
            totalOffset += offset;
        }
        //if nav isn't sticky - navHeight
        if ($("nav.jump-nav.js-stickyItem.is-stuck").length === 0) {
            var navHeight = $('nav.jump-nav')[0].offsetHeight;
            totalOffset -= navHeight;
        }

        $('html, body').animate({ scrollTop: totalOffset }, scrollDuration);
        return false;
    }
}

function headerNav(trigger, menu, subheader) {
    trigger = $(trigger);
    subheader = $(subheader);
    menu = $(menu);

    var mobBackdrop = '<div class="nav__backdrop js-mob-backdrop" style="display: none;"></div>',
        headerHeight = $('.js-header-toggle').outerHeight();

    if ($(window).width() < 960) {
        $('body').append(mobBackdrop);
        $('.js-mob-backdrop').css('top', headerHeight + 'px');
        let menuOpen = false;
        trigger.on('click', function () {
            let closeTarget = $(this).data('toggle-target');
            menu.addClass('is-open');
            menu.addClass('been-clicked');

            toggleHeaderState('.js-header-toggle', closeTarget);

            $('.js-dropdown-trigger').each(function () {
                $(this).removeClass('is-active');
            });
            var headerHeight = $('.js-header').outerHeight(),
                menuHeight = menu.outerHeight();
            menu.css('max-height', (menuHeight - headerHeight) + 'px');

            let menuOpen = true;
            return menuOpen;

            if (menuOpen == true) {
                menu.css('max-height', 'none');
            }
        });

        if (menuOpen == true) {
            $('.js-mob-backdrop').click(function () {
                if (!$('.js-search-dropdown').hasClass('is-open')) {
                    menu.toggleClass('is-open');
                    $('body, html').toggleClass('no-scroll');
                    $('.header').toggleClass('mob-nav-open');
                    menu.addClass('been-clicked');
                    menu.css('max-height', 'none');
                    $(this).toggle();
                }
            });
        }
        if ($('.header--subsite').length < 1) {
            subheader.appendTo(menu);
        }
    }
}

function subheaderFlyout(flyout) {
    flyout = $(flyout);
    flyout.each(function () {
        let flyoutMenu = $(this);
        let flyoutTrigger = $(this).parent();

        flyoutTrigger.addClass('js-flyout-trigger');
        flyoutTrigger.addClass('subheader__list-item--flyout');

        if ($(window).width() > 992) {
            flyoutTrigger.hover(function () {
                flyoutMenu.addClass('is-visible');
            }, function () {
                flyoutMenu.removeClass('is-visible');
            });
        } else {
            flyoutTrigger.append('<span class="js-flyout-subtrigger" aria-selected="false"></span>');
            flyoutMenu.hide();
        }
    });

    if ($(window).width() < 992) {
        $(document).on('click', '.js-flyout-subtrigger', function () {
            $(this).toggleClass('is-active');
            $(this).prev().slideToggle();
        });
    }
}

function dropdownFilter(trigger, dropdown) {
    trigger = $(trigger);
    dropdown = $(dropdown);

    //when trigger is clicked, designated dropdown slides open
    trigger.on('click', function () {
        $(this).toggleClass('is-active');
        dropdown.toggleClass('is-open');
        //dropdown.slideToggle();
        let closeTarget = $(this).data('toggle-target');
        toggleHeaderState('.js-header-toggle', closeTarget);
    });
}


function dropdownMenu(trigger, dropdown) {

    if ($(window).width() > 992) {
        $(dropdown).each(function () {
            var col = $(this).find('.dropdown__column');

            if (col.length > 1) {
                var colCount = col.length,
                    colWidth = 100 / colCount,
                    vpWidth = window.innerWidth,
                    dropdownWidth = ((colWidth * colCount)) * 100;

                col.css('width', colWidth + '%');
                $(this).addClass('dropdown--mega');
            }
        });
    }

    $(dropdown).each(function () {
        $(this).parent().addClass('hasChildren');
        if ($(this).hasClass('dropdown--mega')) {
            var headerHeight = $('.js-header').outerHeight();
            var utilMenu = $('.js-subheader').outerHeight();
            $(this).css({ 'top': utilMenu + headerHeight + 'px' });
        }
    });


    trigger = $(trigger);

    var navBackdrop = function () {
        var backdrop = '<div class="nav__backdrop js-backdrop" style="display: none;"></div>',
            subHeadHeight = $('.subheader').outerHeight(),
            topHeight = $('header').outerHeight();
        $(backdrop).appendTo('body')
        $('.nav__backdrop').css('top', topHeight + subHeadHeight + 'px');

        trigger.click(function () {
            if (trigger.parent().hasClass('is-active')) {
                $('.nav__backdrop').fadeIn();
                $('html').addClass('no-scroll');
                $(dropdown).addClass('is-active');
            } else {
                if (!$('.js-main-site-header').hasClass('is-open')) {
                    $('.nav__backdrop').fadeOut();
                    $('html').removeClass('no-scroll');
                }
                $(dropdown).removeClass('is-active');
            }
        });
        $('.nav__backdrop').click(function () {
            if (!$('.js-search-dropdown').hasClass('is-open') && !$('.js-main-site-header').hasClass('is-open')) {
                $(this).fadeToggle();
                $('html').removeClass('no-scroll');
            } else if ($('.js-main-site-header').hasClass('is-open') && !$('.js-search-dropdown').hasClass('is-open')) {
                //$('.js-main-site-header').removeClass('is-open');
            }
            $('.header--subsite').removeClass('js-main-open');
            trigger.removeClass('is-active');
            trigger.parent().removeClass('is-active');
            $('.nav__backdrop').css('top', topHeight + subHeadHeight + 'px');
            setTimeout(function () {
                $(dropdown).removeClass('is-active');
            }, 500);
        });
    }

    trigger.next(dropdown).attr({
        'tabindex': '-1',
        'aria-hidden': 'true'
    });

    trigger.attr({
        'aria-selected': 'false',
    });

    trigger.on('click', function (e) {
        e.preventDefault();
        var currentDropdown = $(this).next(dropdown);

        $(this)
            .toggleClass('is-active')
            .attr({
                'aria-selected': 'true',
            });

        currentDropdown
            .toggleClass('is-active')
            .attr({
                'tabindex': '1',
                'aria-hidden': 'false'
            });
        $(this).parent().toggleClass('is-active');
        $(this).parent().siblings().removeClass('is-active');
        if ($(this).parent().hasClass('is-active')) {
            $(this).parent().addClass('been-clicked');
        }
        $(this).parent().siblings().find('.dropdown').removeClass('is-active');

        if ($(window).width() < 960) {
            var windowHeight = $(window).outerHeight(),
                headerHeight = $('.header').outerHeight(),
                menuHeight = $('.js-mob-menu').outerHeight();

            if ((menuHeight + headerHeight) > windowHeight) {
                $('.nav__group').addClass('is-active');
                $('.nav__group').css('max-height', windowHeight - headerHeight + 'px');
            } else {
                $('.nav__group').removeClass('is-active');
                $('.nav__group').css('max-height', '');
                $('.hasChildren').each(function () {
                    $(this).removeClass('been-clicked');
                });
            }
        }
    });

    $('.js-dropdown, .dropdown__content').on('click', function (e) {
        e.stopPropagation();
    });
    if ($(window).width() > 992) {
        navBackdrop();
    }
}

function initSelector() {
    $('#js-selector-options').val("default");
    let selectorSwitcher = document.querySelector('.js-selector-options');
    let selectorGroup = document.querySelectorAll('.js-selector-group');

    function resetSelector(groups) {
        groups.forEach(groupElem => {
            groupElem.classList.remove('is-in');
            groupElem.classList.add('is-out');
            groupElem.setAttribute('aria-hidden', 'true')
            groupElem.setAttribute('tabIndex', '-1');
            let childrenEls = groupElem.querySelectorAll('.selector-group__cta');

            childrenEls.forEach(childElem => {
                childElem.setAttribute('tabIndex', '-1')
            });
        });
    };

    document.addEventListener('input', function (event) {
        // Only run on our select menu
        if (event.target.id !== 'js-selector-options') return;
        let activeGroup = document.querySelector('[data-toggled-by="' + event.target.value + '"]');

        resetSelector(selectorGroup);

        if (activeGroup.getAttribute('data-toggled-by') == event.target.value) {
            activeGroup.classList.remove('is-out');
            activeGroup.classList.add('is-in');
            activeGroup.setAttribute('aria-hidden', 'false')
            activeGroup.setAttribute('tabIndex', '1');
            let childrenEls = activeGroup.querySelectorAll('.selector-group__cta');

            childrenEls.forEach(childElem => {
                childElem.setAttribute('tabIndex', '1')
            });
        }

    }, false);
}


function initPrintPage(printTrigger) {
    var trigger = $(printTrigger);

    trigger.on('click', function () {
        $(this).closest('.section').addClass('section--printed');
        window.print();
    });
}

function dropdownSearch(trigger, dropdown) {
    trigger = $(trigger);
    dropdown = $(dropdown);

    var searchField = dropdown.find('.form-field');
    var alertWasVisible = false; // Track if alert was visible before opening search

    var toggleFocus = function (formField) {
        if (formField.hasClass('is-focused')) {
            formField.focus();
        } else {
            formField.blur();
        }
    };

    var closeDropdown = function () {
        trigger.removeClass('is-active');
        dropdown.removeClass('is-open'); 

        if (!$('.js-main-site-header').length) {
            $('.js-backdrop').fadeOut();
            $('html').removeClass('no-scroll');
        }

        if ($(window).width() > 992) {
            $('.subheader__list').fadeIn();
            trigger.text('Search');
        }
        if (!document.cookie.match(new RegExp('(^| )' + "Alert" + '=([^;]+)')) && alertWasVisible) {
            $('.alert').fadeIn();
        }
    };

    trigger.attr({
        'role': 'tab',
        'aria-selected': 'false',
        'aria-expanded': 'false',
    });

    dropdown.attr({
        'role': 'tabpaenl',
        'aria-hidden': 'true',
    });

    // Flag used to determine if close function should run
    let canClose = false;
    trigger.on('click', function (e) {
        if (canClose == false) {
            e.preventDefault();
            $(this).toggleClass('is-active');
            dropdown.addClass('is-open');
            searchField.addClass('is-focused');
            toggleFocus(searchField);

            var searchHeight = $('.header-search.is-open').outerHeight(),
                subheadHeight = $('.js-subheader').outerHeight(),
                searchBackdropTop = searchHeight + subheadHeight;

            if (!document.cookie.match(new RegExp('(^| )' + "Alert" + '=([^;]+)'))) {
                alertWasVisible = $('.alert').is(':visible');
                $('.alert').fadeOut();
            }

            if (!$('.js-main-site-header').length) {
                $('.js-backdrop').css('top', searchBackdropTop + 'px').fadeIn();
            }


            if ($(window).width() > 992) {
                $('.subheader__list').fadeToggle();
                $(this).text('Close');
            }

            if ($(window).width() < 992) {
                let closeTarget = $(this).data('toggle-target');
                toggleHeaderState('.js-header-toggle', closeTarget);
            }

            $('html').addClass('no-scroll');
            canClose = true;
        } else {
            closeDropdown();
            toggleFocus(searchField);
            canClose = false;
        }
    });

    $(document).on('click', '.js-backdrop', function () {
        if (!$('.js-main-site-header').hasClass('is-open') && $('.js-search-dropdown').hasClass('is-open')) {
            closeDropdown();
            toggleFocus(searchField);
            canClose = false;
        }
    });
}

function initScrollAnimation(animatedObj) {
    animatedObj = $(animatedObj);

    animatedObj.each(function (id) {
        var $this = $(this);

        if ($this.isInViewport()) {
            $this.addClass('is-animated');
        }

        $(window).on('resize scroll', function () {
            if ($this.isInViewport()) {
                $this.addClass('is-animated');
            }
        });
    });
}

function scrollFix(scrolledEl, offsetEl, scrollAmount) {
    if (scrolledEl.length) {
        scrolledEl = $(scrolledEl);

        if (typeof offsetEl == 'number') {
            var offsetAmount = offsetEl;
        } else {
            offsetEl = $(offsetEl);
            var offsetAmount = offsetEl.outerHeight(true);
        }

        if (typeof scrollAmount == 'number') {
            var amountScrolled = scrollAmount;
        } else {
            if (scrolledEl.length) {
                var amountScrolled = scrolledEl.offset().top;
            }
        }

        var hasBeenScrolled = false;
        $(window).scroll(function () {
            if ($(this).scrollTop() > amountScrolled && !hasBeenScrolled) {
                if (offsetEl) {
                    scrolledEl.addClass('is-stuck').css('top', offsetAmount);
                    $("header").css('margin-bottom', '0px');
                } else {
                    scrolledEl.addClass('is-stuck').css('top', '0');
                }
                hasBeenScrolled = true;
            } else if ($(this).scrollTop() <= amountScrolled) {
                scrolledEl.removeClass('is-stuck');
                hasBeenScrolled = false;
                $("header").css('margin-bottom', '0px');
            }
        });
    }
};

function stickyHeaderOnScroll() {
    var mainHeader = $('header.js-header');
    var subsiteHeader = $('.header--subsite');
    var scrollThreshold = 100; // Adjust this value to control when the sticky class is added
    
    $(window).on('scroll', function () {
        var scrollTop = $(this).scrollTop();
        
        // Only handle main header if subsite header is not present
        if (!subsiteHeader.length && mainHeader.length) {
            if (scrollTop > scrollThreshold) {
                mainHeader.addClass('main-scroll-fixed');
            } else {
                mainHeader.removeClass('main-scroll-fixed');
            }
        }
    });
};

function openTab() {
    var tabLink = $('.js-tabLinks'),
        tabContent = $('.js-tabContent');

    tabLink.each(function () {
        var content = $(this).children('a').attr('data-target');

        if ($(this).hasClass('defaultOpen')) {
            $(this).addClass('active');
            tabContent.each(function () {
                if ($(this).is('#' + content)) {
                    $(this).addClass('active');
                }
            });
        }
        $(this).click(function () {
            $(this).addClass('active');
            $(this).siblings().removeClass('active');
            if ($(this).text() == 'Map') {
                $('.location').addClass('map-active');
            } else {
                $('.location').removeClass('map-active');
            }
            // tabContent.each(function(){
            //     if ($(this).is('#' + content)){
            //         $(this).addClass('active');
            //         $(this).siblings().removeClass('active');
            //     }
            // });
        });
        $(this).hover(function () {
            $(this).addClass('active');
            $(this).siblings().removeClass('active');
            tabContent.each(function () {
                if ($(this).is('#' + content)) {
                    $(this).addClass('active');
                    $(this).siblings().removeClass('active');
                }
            });
        });
    });
}

function interrupt(object, trigger, content) {
    var object = $(object),
        trigger = $(trigger),
        content = $(content),
        interruptBackdrop = function () {
            var backdrop = '<div class="interrupt__backdrop"></div>'

            $(backdrop).appendTo('body');
            $('.interrupt__backdrop').css({ 'top': '0', 'left': '0' });
            $('html').addClass('no-scroll');
            $('.interrupt__backdrop').click(function () {
                $(this).fadeToggle();
                $(content).fadeToggle('400');
                $(object).removeClass('is-active');
                $('html').removeClass('no-scroll');
            });
            trigger.click(function () {
                $('.interrupt__backdrop').fadeToggle();
                $(content).fadeToggle('400');
                $(object).removeClass('is-active');
                $('html').removeClass('no-scroll');
                var name = "Interrupt";
                var value = "True";
                var expires = "";
                document.cookie = name + "=" + (value || "") + expires + "; path=/";
            });
        };

    if (object.length) {
        //var intContentHeight = content.outerHeight();
        interruptBackdrop();
        //console.log(content.outerHeight());
        object.addClass('is-active');
        //object.css('min-height', intContentHeight + 'px');
        content.addClass('is-active');
    }
}

function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

function serviceFilter() {
    let allLetters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    var value = "";
    if ($('.services-filter').length) {
        var input = $('.services-filter input[name="keyword"]');
        input.on("keyup", function () {
            value = $(this).val().toLowerCase();
            $(".result-item__title").filter(function () {
                $(this).parents('.result-item').toggle($(this).text().toLowerCase().indexOf(value) > -1);
            });

            // Get all elements with the same parent letter
            for (let letter of allLetters) {
                let letterParent = document.getElementById(letter);
                var allForLetter = document.querySelectorAll(`[data-parent-letter='${letter}']`);
                var hiddenCount = 0;
                for (let elem of allForLetter) {
                    if ($(elem).is(':hidden')) {
                        hiddenCount++;
                    }
                }

                if (letterParent) {
                    let show = hiddenCount != allForLetter.length;
                    $(letterParent).toggle(show);

                    let letterLink = document.getElementById(`Service${letter}`);
                    if (letterLink) {
                        $(letterLink).toggleClass('is-disabled', !show);
                        $(letterLink).prop('disabled', !show);
                    }
                }

            }

            var results = $('.js-service-group');
            results.each(function () {
                var resultGroup = $(this);
                var total = resultGroup.children('.result-item').length;
                if (resultGroup.children('.result-item:hidden').length == total) {
                    // action when all are hidden
                    resultGroup.hide();
                }

                if (input.val() == '' && $(this).is(":hidden")) {
                    resultGroup.show();
                }
            });

        });

        input.on("keydown", function (event) {
            if (event.which == 13) {
                event.preventDefault();
                dataLayer.push({
                    'event': 'Services - Filter',
                    'value': value
                });
            }
        });


        let backToTop = document.querySelector('.b2t');
        if (backToTop) {
            backToTop.addEventListener('click', function () {
                let scrollTo = 'html';
                $('html, body').animate({ scrollTop: $(scrollTo).offset().top - 50 }, 130);
            });
        }

        let mobServiceJumpTo = $('.js-mob-service-scroll');
        mobServiceJumpTo.on('change', function () {
            let value = $(this).val();
            let target = document.getElementById(value);

            if (target && value) {
                let scrollTo = target;
                let fixHeader = document.querySelector('.services-filter.js-stickyItem');
                let offsetHeight;
                if (fixHeader.classList.contains('is-stuck')) {
                    offsetHeight = (fixHeader.offsetHeight + 40);
                    $('html, body').animate({ scrollTop: $(scrollTo).offset().top - offsetHeight }, 130);
                } else {
                    offsetHeight = (fixHeader.offsetHeight + 160);
                    $('html, body').animate({ scrollTop: $(scrollTo).offset().top - offsetHeight }, 130);
                }

            }
        });

        var letters = document.querySelectorAll('.services-filter__letters button');
        for (let letter of letters) {
            letter.addEventListener('click', function () {
                let text = letter.innerHTML;
                let target = document.getElementById(text);

                if (target && text) {
                    let scrollTo = target;
                    let fixHeader = document.querySelector('.services-filter.js-stickyItem');
                    let offsetHeight;
                    if (fixHeader.classList.contains('is-stuck')) {
                        offsetHeight = (fixHeader.offsetHeight + 40);
                        $('html, body').animate({ scrollTop: $(scrollTo).offset().top - offsetHeight }, 130);
                    } else {
                        offsetHeight = (fixHeader.offsetHeight + 160);
                        $('html, body').animate({ scrollTop: $(scrollTo).offset().top - offsetHeight }, 130);
                    }

                }
            });
        }
    }
};

function filterNav() {
    if ($('.filter-nav').length) {
        var filterItems = $('.filter-nav').find('.filter-nav__item');

        filterItems.each(function () {
            $(this).click(function () {
                filterItems.removeClass('is-active');
                $(this).addClass('is-active');
            });
        });
    }
}

async function initWaitTime() {
    // Updates the time sidebar on the location pages
    var timeBlock = $(".time-block--is-sidebar");
    if (timeBlock.length === 0) return;

    timeBlock.each(async function () {
        var $block = $(this);
        var waitTimeId = $block.data("wait-time-id");

        let number = helpers.extractNumber(waitTimeId);
        let waitTime = await getWaitTime(number);

        let $times = $block.find('.minutes');
        let $suffix = $block.find('.minutes__suffix');

        if ($times.length) {
            if ((!waitTime || waitTime === 'N/A') && $suffix.length) {
                waitTime = 'Closed';
                $suffix.text('');
            } else if (waitTime && waitTime.indexOf("-") > -1) {
                waitTime = waitTime.split('-').pop().trim();
            }

            $times.text(waitTime);
        }
    });
}

async function getWaitTime(timeId) {
    let waitTime = null;

    return new Promise(async (resolve, reject) => {

        if (timeId) {

            let apiUrl = `/nsapi/waittimes/${timeId}`;

            const response = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            })
                .then(response => response.json());

            let waitTime = response.hospital_waits ? response.hospital_waits.current_wait : '';
            resolve(waitTime);

            if (waitTime != 'N/A') {
            }
        }
        else {
            resolve(waitTime);
        }
    });
}

function videoModal() {
    $('.js-modal-trigger').modaal({
        type: 'video',
        background: '#002856',
        fullscreen: false,
        after_open: function () {
            $('html').addClass('modaal-noscroll');
        },
        after_close: function () {
            $('html').removeClass('modaal-noscroll');
        }
    });
}

function mainSiteHeaderToggle() {
    var attrTarget = $('.js-main-site-trigger').attr('data-toggle-target'),
        targetClass = "." + attrTarget,
        target = $(targetClass),
        navBackdrop = function () {
            var backdrop = $('.nav__backdrop');

            backdrop.css('z-index', '155').fadeIn();
            //removed below code 590-599 to keep backdrop funkiness from happening.
            //            backdrop.click(function(){
            //                if ($('.js-search-dropdown').hasClass('is-open')){
            //                    $('.js-search-dropdown').removeClass('is-open');
            //                }
            //                else if (!$('.js-search-dropdown').hasClass('is-open') && !$('.dropdown--mega').hasClass('is-active')){
            //                    $(this).fadeOut();
            //                    $('html').removeClass('no-scroll');
            //                    target.fadeOut();
            //                }
            //            });
        },
        returnBtn = function () {
            var retbtn = $('.js-return-btn')
            retbtn.click(function (e) {
                e.preventDefault();
                target.fadeOut().removeClass('is-open');
                $('.nav__backdrop').fadeOut().css('z-index', '150');
                $('html').removeClass('no-scroll');
                $('.header--subsite').removeClass('js-main-open');
                var headerHeight = $('.js-header').outerHeight();
                $('.js-backdrop').css('top', headerHeight + 'px');
            });
        }
    $('.js-main-site-trigger').click(function () {
        target.fadeToggle();
        target.toggleClass('is-open');
        $('html').addClass('no-scroll');
        navBackdrop();
        var mainsiteNavHeight = $('.js-main-site-header').outerHeight();
        $('.js-backdrop').css('top', mainsiteNavHeight + 'px');
        returnBtn();
        $('.header--subsite').toggleClass('js-main-open');
    });
}

function filterShowMore(content, trigger) {
    var trigger = $(trigger),
        contentLength = content.length;

    trigger.each(function () {
        if ($(this).siblings(content).length > 6) {
            $(this).siblings(content).slice(6, 999).hide();
            trigger.show();
        }
        $(this).on('click', function (e) {
            e.preventDefault();
            $(this).siblings(content + ':hidden').slice(0, 6).slideDown();
            if ($(this).siblings(content + ':hidden').length == 0) {
                $(this).fadeOut('slow');
            }
        });
    });
}

function isMacCheck() {
    if (navigator.userAgent.indexOf('Mac') > 0) {
        $('body').addClass('mac-os');
    }
}

function initMyLocation() {
    let myLocElem = document.getElementById('my-location');
    if (myLocElem) {
        myLocElem.addEventListener('click', () => getLocation(), false);
    }

    let locButtons = document.querySelectorAll('.btn-use-location');
    for (let button of locButtons) {
        button.addEventListener('click', function () {
            let target = this.dataset.target;
            getLocationZip(target);
        });
    }
}

async function getLocation() {
    const response = await fetch('https://geolocation-db.com/json/')
        .then(response => response.json());

    let filterText = document.getElementById('filterZip');
    if (filterText && response.city && response.state && response.postal) {
        filterText.value = `${response.city}, ${response.state} ${response.postal}`;
    }

    let coordsElem = document.getElementById('locationCoords');
    if (coordsElem && response.latitude && response.longitude) {
        coordsElem.value = `${response.latitude},${response.longitude}`;
    }
}

async function getLocationZip(target) {
    const response = await fetch('https://geolocation-db.com/json/')
        .then(response => response.json());

    let input = document.getElementById(target);
    if (input && response.postal) {
        input.value = response.postal;
    }
}

function providerRatings() {
    $('.provider-ratings').each(function () {
        var $stars = $(this).find('.filled'),
            $rating = $stars.attr('starrating'),
            $tooltip = $(this).find('.tooltip');

        $stars.css('width', $rating * 20 + '%');

        $tooltip.hover(function (e) {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');

            } else {
                $(this).addClass('active');
            }
            e.stopPropagation();
        });

        $(document).hover(function (e) {
            if (!$(e.target).hasClass('active')) {
                $('.provider-ratings .tooltip').removeClass('active');
            }
        });
    });
}





function checkForSevenItems() {
    $('.nav__group>li .js-dropdown .dropdown__column').each(function () {
        if ($(this).children('li').length > 7) {
            $(this).addClass('js-grid-2col');
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.classList.remove("lazy");
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Possibly fall back to event handlers here
    }
});


$(function () {
    interrupt('.interrupt', '.interrupt__close', '.interrupt__content');
    headerNav('.js-menu-control', '.js-mob-menu', '.js-subheader');
    subheaderFlyout('.js-subheader-flyout');
    dropdownMenu('.js-dropdown-trigger', '.js-dropdown');
    dropdownSearch('.js-search-trigger', '.js-search-dropdown');
    dropdownSearch('.js-mobile-search-trigger', '.js-search-dropdown');
    serviceFilter();
    filterNav();
    initPrintPage('.js-print-page');
    initWaitTime();

    sliders.initSlider('.js-slider');

    SideNav.initSideNav('.js-nav-item');
    SideNav.initMobSideNav('.js-sidenav', 992);

    initScrollAnimation('.js-animated');

    helpers.initReveal('.js-sidenav-mobile', '.js-sidenav-drop', '', true);
    helpers.initReveal('.js-prev-tigger', '.js-prev-dropdown', '', true);
    helpers.initReveal('.js-hours-toggle', '.js-hours-list', '', true);
    helpers.initReveal('.js-expand-locations', '.js-reveal-locations', '', false);
    helpers.initReveal('.js-share', '.js-share-dropdown', '.js-share-close', false);
    helpers.initReveal('.js-service-filter-t', '.js-service-filter-d', '', false);
    filter.initFilter();

    scrollFix('.js-stickyItem');
    //scrollFix('.js-header');
    stickyHeaderOnScroll();
    smoothScroll('.js-anchor-link', '1000');
    dropdownFilter('.js-filter-trigger', '.js-filter-dropdown');
    dropdownFilter('#filterTrigger', '.location__filter');
    openTab();
    initSelector();
    videoModal();
    simpleMap.init();
    finddoctormeetteamtabs.init();
    newsCenter.init();
    searchFilters.init();
    filterShowMore('.form-check', '.more-trigger');
    filterNavDropdown.init();
    initMyLocation();
    offsetAnchor();
    checkForSevenItems();

    $('#range_start').daterangepicker({
        opens: 'right',
        singleDatePicker: true,
        showDropdowns: true,
        autoUpdateInput: false,
        autoApply: true
    }, function (chosen_date) {
        $(this.element[0]).val(chosen_date.format('DD/MM/YYYY'));
    });

    $('#range_end').daterangepicker({
        opens: 'left',
        singleDatePicker: true,
        showDropdowns: true,
        autoUpdateInput: false,
        autoApply: true
    }, function (chosen_date) {
        $(this.element[0]).val(chosen_date.format('DD/MM/YYYY'));
    });

    $('nav.jump-nav.js-stickyItem a.jump-nav__link').click(function (e) {
        smoothScrollTo(e.currentTarget.attributes[1].nodeValue, 1);
    });

    $('.js-toggle-tab-card').on('click', function () {
        $('.tab-card__item').toggleClass('is-active');
        $(this).parent('.tab-card__item').toggleClass('is-active');

        let state = $(this).attr('aria-hidden');
        if (state == true) {
            $('.js-toggle-tab-card').attr('aria-hidden', 'true');
            $(this).attr('aria-hidden', 'false');
        } else {
            $('.js-toggle-tab-card').attr('aria-hidden', 'false');
            $(this).attr('aria-hidden', 'true');
        }

        $('.tab-card__item').find('.form').attr('aria-hidden', 'true');
        $(this).siblings('.form').attr('aria-hidden', 'false');
    });

    $('.js-hero-buttons').each(function () {
        var buttons = $(this);
        var hero = buttons.parents('.js-hero');
        if ($(window).width() < 768) {
            buttons.insertAfter(hero);
        }
    });

    $('.js-header-close').on('click', function (e) {
        e.preventDefault();
        let closeEl = $(this).attr('data-closes');
        toggleHeaderState('.js-header-toggle');
        $('.' + closeEl).toggleClass('is-open');
        $(this).attr('data-closes', '');
    });

    /*
    $('input[type="date"]').daterangepicker({
        "singleDatePicker": true,
        "showDropdowns": true,
        "autoApply": true,
        "showCustomRangeLabel": false,
        "startDate": "06/09/2020",
        "endDate": "06/15/2020",
        "drops": "auto"
    }, function (start, end, label) {
    });
    */

    //data layer onclick events
    $('.subheader__list a').on('click', function (e) {
        var linkText = e.currentTarget.innerText;
        dataLayer.push({
            'event': 'Header',
            'value': linkText
        });
    });

    $('.quick__link').on('click', function (e) {
        dataLayer.push({
            'event': 'Header - Popular Quick Links',
            'value': e.currentTarget.innerText
        });
    });

    $('.js-header a').on('click', function (e) {
        dataLayer.push({
            'event': 'Top Navigation',
            'value': e.currentTarget.innerText
        });
    });

    $('.footer a').on('click', function (e) {
        var dataText = "";
        if (e.currentTarget.innerText != "") {
            dataText = e.currentTarget.innerText;
        }
        else if (e.currentTarget.childNodes[0].className.indexOf("facebook") > 0) {
            dataText = "Facebook";
        }
        else if (e.currentTarget.childNodes[0].className.indexOf("twitter") > 0) {
            dataText = "Twitter Northside";
        }
        else if (e.currentTarget.childNodes[0].className.indexOf("linkedin") > 0) {
            dataText = "LinkedIn";
        }
        else if (e.currentTarget.childNodes[0].className.indexOf("instagram") > 0) {
            dataText = "Instagram";
        }
        else if (e.currentTarget.childNodes[0].className.indexOf("youtube") > 0) {
            dataText = "YouTube";
        }
        else if (e.currentTarget.children[0].currentSrc.indexOf("twitterMD") > 0) {
            dataText = "Northside GA MD";
        }
        else if (e.currentTarget.children[0].currentSrc.indexOf("glassdoor") > 0) {
            dataText = "Glassdoor";
        }

        dataLayer.push({
            'event': 'Footer',
            'value': dataText
        });
    });

    $(".breadcrumbs a").on('click', function (e) {
        var dataList = e.target.parentNode.childNodes;
        var dataValue = "";
        for (var i = 0; i < dataList.length; i++) {
            if (dataList[i].tagName == "A") {
                dataValue += dataList[i].innerText + ", ";
            }
        }
        dataLayer.push({
            'event': 'Breadcrumb',
            'value': dataValue
        });
    });

    $('ul.list-blank.sidenav__nav a').on('click', function (e) {
        dataLayer.push({
            'event': 'LH Navigation',
            'value': e.currentTarget.innerText
        });
    });

    $('.hero__content a.btn.btn--tertiary').on('click', function (e) {
        dataLayer.push({
            'event': 'Homepage - Hero',
            'value': 'Our Services'
        });
    });

    $('.selector-group__holder a').on('click', function (e) {
        var amSelected = $('#js-selector-options')[0].value;
        dataLayer.push({
            'event': 'Homepage - How Can We Help You',
            'value': '<�I am a� ' + amSelected + ' ' + e.currentTarget.innerText + '>'
        });
    });

    $('.v-tabs a').on('click', function (e) {
        dataLayer.push({
            'event': 'Homepage - Services Module',
            'value': e.currentTarget.innerText
        });
    });

    $('.slider__item.active .lr--reverse a').on('click', function (e) {
        dataLayer.push({
            'event': 'Homepage - Patient Story Carousel',
            'value': e.currentTarget.innerText
        });
    });

    $('.card a.result__title.result__title--feat').on('click', function (e) {
        dataLayer.push({
            'event': 'Homepage - Latest News Carousel',
            'value': e.currentTarget.innerText
        });
    });

    $('#updateProviderSubmit').on('click', function (e) {
        var zipValue = $('input#locZip')[0].value;
        var specialtyValue = $('#locSpecialty')[0].value;
        dataLayer.push({
            'event': 'Homepage - Find a Provider Module Search',
            'zip': zipValue,
            'value': specialtyValue
        });
    });

    $('.result.result--row a').on('click', function (e) {
        dataLayer.push({
            'event': 'Homepage - Upcoming Events',
            'value': e.currentTarget.innerText
        });
    });

    //Locations Page Search NOT WORKING
    $('button.btn.btn--tertiary').on('click', function (e) {
        var searchTearm = $('.input-group--respond input.form-control')[0].value;
        dataLayer.push({
            'event': 'Locations - Search',
            'value': e.currentTarget.innerText
        });
    });

    //Location buttons NOT WORKING
    $('.location__buttons.btn-group a').on('click', function (e) {
        var loc = e.currentTarget;
        dataLayer.push({
            'event': 'Locations - Results Selection',
            'location': loc,
            'value': e.currentTarget.innerText
        });
    });

    //NOT WORKING
    $('.location__item--info-data a').on('click', function (e) {
        var loc = e.currentTarget;
        dataLayer.push({
            'event': 'Locations - View Location',
            'value': e.currentTarget.innerText
        });
    });

    $('.accent-section.accent-section--full a').on('click', function (e) {
        dataLayer.push({
            'event': 'Locations - At This Location',
            'value': e.currentTarget.innerText
        });
    });

    $('#updateTemplateSubmit').on('click', function (e) {
        var specialty = $('#doctorSpecialty')[0].value;
        var name = $('#doctorSpecialtyAndNameSearch')[0].value;
        dataLayer.push({
            'event': 'Provider - Search',
            'specialty': specialty,
            'name': name

        });
    });

    $('input#updateFilterSubmit').on('click', function (e) {
        var radius = $('#radiusSelect')[0].value;
        var specialties = $('#specialtyDDL')[0].value;
        var affiliation = $('#hospitalSelect')[0].selectedOptions[0].label;
        var gender = $('#genderSelect')[0].value;
        var initial = $('.fad-filter .alphabet-filter .alphabet-filter__group input[type="radio"]:checked')[0].value;

        dataLayer.push({
            'event': 'Locations - Location Type Filter',
            'radius': radius,
            'specialties': specialties,
            'hospital affiliation': affiliation,
            'gender': gender,
            'doctorLastInitial': initial

        });
    });

    $('.physician-block a.btn.btn--ghost-primary.btn--block').on('click', function (e) {
        var name = e.currentTarget.children[0].innerText
        var specialties = e.currentTarget.children[1].innerText

        dataLayer.push({
            'event': 'Provider - Results Selection',
            'provider': name,
            'specialties': specialties
        });
    });

    $('.sf-list-item a.accordion__title').on('click', function (e) {
        dataLayer.push({
            'event': 'FAQ - View Answer',
            'value': e.currentTarget.innerText
        });
    });

    $('section.hero.js-hero.hero--sm.hero--events.hero--search #filterSubmit').on('click', function (e) {
        var category = $('#SearchTag')[0].value;
        var keyword = $('#SearchKeywords')[0].value;
        dataLayer.push({
            'event': 'Classes & Events Search',
            'category': category,
            'keyword': keyword
        });
    });

    $('.card__body--event a.btn.btn--ghost-primary.btn--block').on('click', function (e) {
        var name = e.currentTarget.childNodes[1].innerText;
        var online = e.currentTarget.childNodes[3].innerText;
        dataLayer.push({
            'event': 'Classes & Events - View Detail',
            'name': name,
            'online class': online
        });

    });


    // jump nav - move li items to more dropdown menu if the number of jump nav items exceeds the specified number
    // of items for the width.

    function SplitContentList() {
        var $width = $(window).width();
        if ($width <= 960) {
            $('.split-content-list').each(function () {
                var $moveItem = $(this).find('.js-lastOnMobile');
                var $destination = $moveItem.parents('.wrapper');
                $moveItem.appendTo($destination);
            });
        } else if ($width > 960) {
            $('.split-content-list').each(function () {
                var $moveItem = $(this).find('.js-lastOnMobile');
                var $destination = $(this).find('.split-content-list__title');
                $moveItem.insertAfter($destination);
            });
            mainSiteHeaderToggle();
        }
    }

    function offsetAnchor() {
        var navHeight = $('jump-nav__anchor').height;
        var url = location.href;
        if (url.indexOf('#') > -1) {
            // jQuery has issues with selectors containing ampersands, percents, etc
            // Get the element by ID w/ plain JS instead
            var hash = location.hash ? decodeURIComponent(location.hash.substr(1)) : '';
            let scrollToElem = document.getElementById(hash);

            // If the element we're scrolling to is a jump nav anchor, offset by the jump nav height
            let offset = scrollToElem && scrollToElem.classList.contains('jump-nav__anchor') ? navHeight : 0;
            smoothScrollTo(scrollToElem, 0, offset);
        }
    }

    function setJumpNav() {
        var maxItems = 7;
        var minItems = 3;
        var wwidth = $('.jump-nav .wrapper').innerWidth();
        var maxWidth = parseInt($('.jump-nav .wrapper').css('max-width'));
        var parent = $('.jump-nav__items');
        var items = $('.jump-nav__item');
        var more = $('.jump-nav__more ul');
        // maxItems - 1 | 1 is deducted to exclude "more" size
        var averageSize = maxWidth / (maxItems - 1);
        var itemCount = Math.floor(wwidth / averageSize);
        itemCount = Math.max(minItems, Math.min(itemCount, (maxItems - 1)));

        // if more than 7 items, show "more"
        if (items.length >= 7) {
            $('.jump-nav__more').css('display', 'flex');
        }
        if (parent && parent[0] && parent[0].children.length == 0) {
            // reset nav
            items.prependTo(parent);
        }
        // split items add to "more"
        items.slice(itemCount).appendTo(more);
    }

    var r_timer;
    window.addEventListener('resize', function () {
        // simulate resize complete event
        clearTimeout(r_timer);
        r_timer = setTimeout(function () {
            filter.initFilter();
            SplitContentList();
            setJumpNav();
        }, 250);
    });
    // init jump nav
    filter.initFilter();
    SplitContentList();
    setJumpNav();

    $('.alert__close').on('click', function () {
        $('.alert').hide();
        var name = "Alert";
        var value = "True";
        var expires = "";
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    });

    helpers.applyTelLinks();

    providerRatings();
});
